'use es6';

import { MIN_SEARCH_LENGTH } from 'customer-data-objects/search/ElasticSearchConstants';
import CjkCharacterRegExp from 'I18n/constants/regex/CJK';
export const isCjkCharacterContained = (str = '') => Boolean(str) && CjkCharacterRegExp.test(str);
export const isOfMinSearchLength = query => !!query && (query.length >= MIN_SEARCH_LENGTH || isCjkCharacterContained(query));